<template>
    <div style="display:flex;width:100%">
        <div class="content">
            <div><img class="imgScore" v-if="SampleInfo.TargetPic!=''" :src="'data:image/png;base64,'+SampleInfo.TargetPic"/></div>
            <div style="width:100%">
                <div class="nameTarget">目标化合物:
                    <span v-if="SampleInfo.TargetName != undefined">
                                {{SampleInfo.TargetName}}
                    </span>
                </div>
                <div class="casName">
                    <span style="color:#8f9091;">CAS</span>
                    <span v-if="SampleInfo.CAS != undefined" style="color: #1f8dff;">
                                {{SampleInfo.CAS}}
                            </span>
                </div>
            </div>
        </div>
        <div class="content">
            <div style="width: 73%;"></div>
            <div><img src="../../../assets/imgs/cup.svg" style="width: 60px"></div>
            <div style="padding: 27px 0 0 0;font-size: 21px;">推荐评分：<span style="color: #fb9f15;font-size: 22px;">{{SampleInfo.score}}</span></div>
        </div>
    </div>  
</template>

<script>
    export default {
        name: "GetScore",
        data() {
          return {
          }
        },
        created() {
        },
        props: {
            SampleInfo: {},
        }
    }
</script>

<style scoped>
    @import "../../../assets/element-component.css";

.content{
    height: 90px;
    width: 50%;
    display:flex;
}
.imgScore{
    width: 160px;
    border: 1px solid #d2d2d3;
    box-sizing: border-box;
    padding: 3px 5px 3px 5px;
}
.nameTarget{
    font-size: 18px;
    padding: 0 0 0 15px;
    font-weight: 600;
}
.casName{
    font-size: 24px;
    margin: 10px 0 0 18px;
}
</style>